export const SEARCHPAGE_ETFS_GET_REQUEST = "SEARCHPAGE_CATALOG_GET_REQUEST";
export const SEARCHPAGE_ETFS_GET_SUCCESS = "SEARCHPAGE_CATALOG_GET_SUCCESS";
export const SEARCHPAGE_ETFS_GET_FAILED = "SEARCHPAGE_CATALOG_GET_FAILED";

export const FUNDPAGE_REPORT_GET_REQUEST = "FUNDPAGE_REPORT_GET_REQUEST";
export const FUNDPAGE_REPORT_GET_SUCCESS = "FUNDPAGE_REPORT_GET_SUCCESS";
export const FUNDPAGE_REPORT_GET_FAILED = "FUNDPAGE_REPORT_GET_FAILED";